// extracted by mini-css-extract-plugin
export default {"hidescrollbar":"CandidateDashboardCVManager_hidescrollbar__EuCqM"};